import { parse } from 'querystring'
import lodash, { reject } from 'lodash'
import qs from 'qs'
import { getSlotDataList } from '@xiaoduo/plugin_sdk'
import pathRegexp from 'path-to-regexp'
import { message } from 'antd'

/* eslint no-useless-escape:0 import/prefer-default-export:0 */
const reg =
  /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/

export const pwdRule =
  /^(?=.*[~!@#$%^&*()_+`\-={}\[\]:;"'<>,.?\/])(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/

export const isUrl = (path: string): boolean => reg.test(path)

export const isAntDesignPro = (): boolean => {
  return window.location.hostname === 'preview.pro.ant.design'
}

// 给官方演示站点用，用于关闭真实开发环境不需要使用的特性
export const isAntDesignProOrDev = (): boolean => {
  const { NODE_ENV } = process.env
  if (NODE_ENV === 'development') {
    return true
  }
  return isAntDesignPro()
}

export const getPageQuery = () => parse(window.location.href.split('?')[1])

/**
 * props.route.routes
 * @param router [{}]
 * @param pathname string
 */
export const getAuthorityFromRouter = <T extends Route>(
  router: T[] = [],
  pathname: string
): T | undefined => {
  const authority = router.find(
    ({ routes, path = '/' }) =>
      (path && pathRegexp(path).exec(pathname)) ||
      (routes && getAuthorityFromRouter(routes, pathname))
  )
  if (authority) return authority
  return undefined
}

export const getRouteAuthority = (path: string, routeData: Route[]) => {
  let authorities: string[] | string | undefined
  routeData.forEach((route) => {
    // match prefix
    if (pathRegexp(`${route.path}/(.*)`).test(`${path}/`)) {
      if (route.authority) {
        authorities = route.authority
      }
      // exact match
      if (route.path === path) {
        authorities = route.authority || authorities
      }
      // get children authority recursively
      if (route.routes) {
        authorities = getRouteAuthority(path, route.routes) || authorities
      }
    }
  })
  return authorities
}

export const downloadLink = (url: string, params?: any, fileName?: string) => {
  const a = document.createElement('a')
  a.href = `${url}?${qs.stringify({ ...params, current_page: undefined, page_size: undefined })}`
  // a.target = '_blank';
  if (fileName) {
    a.download = fileName
  }
  document.body.appendChild(a)
  a.click()
}

export const downloadBlob = (blob: any, fileName?: string) => {
  const a = document.createElement('a')
  const url = window.URL.createObjectURL(blob)
  a.href = url
  if (fileName) {
    a.download = fileName
  }
  document.body.appendChild(a)
  a.click()
  window.URL.revokeObjectURL(url)
}

export const getTree = (list) => {
  const treeList: any[] = []
  const map = {}
  list?.forEach((item) => {
    if (!item?.children) {
      item.children = []
    }
    map[item.department_id] = item
  })

  list?.forEach((item) => {
    // 通过pid在做成的map中找到父级，将子级插入到父级中
    const parent = map[item.pid]
    if (parent) {
      parent.children.push(item)
    } else {
      treeList.push(item)
    }
  })
  return treeList
}

export const getOptions = (tree: any) => {
  tree.forEach((item: any) => {
    if (!item.children.length) {
      delete item.children
    } else {
      getOptions(item.children)
    }
  })
  return tree
}

export const getPossibleResult = (departmentList: any, checkedIds: string[]) => {
  // 取出数据权限勾选的项
  const fm = (arrRoot: any, ids: string[]) => {
    const temp: any = []
    const fn = (tree: any, arr: any[], pid: string) => {
      const newArr = arr.slice(0)
      newArr.push({ ...tree, pid })
      if (ids.includes(tree?.department_id)) {
        if (tree?.children && tree?.children.length) {
          tree?.children.forEach((element: any) => {
            fn(element, newArr, tree?.department_id)
          })
        } else {
          temp.push(newArr)
        }
      } else if (tree?.children && tree?.children.length) {
        tree?.children.forEach((element: any) => {
          fn(element, newArr, tree?.department_id)
        })
      }
    }
    fn(arrRoot, temp, '')
    return temp
  }
  const allArr = fm(departmentList?.[0], checkedIds)
  // 合并数据
  const mergeData = lodash.union(...allArr)
  // 清洗数据
  const clearResult = mergeData?.map((m: any) => {
    m.children = []
    return m
  })
  // 组成一颗新树
  const newTree = getTree(clearResult)
  // children为空的进行转化
  const result = getOptions(newTree)
  return result
}

export function handleMarkVisited(nick) {
  const iframe = document.createElement('iframe')
  iframe.src = `https://amos.alicdn.com/getcid.aw?v=3&groupid=0&s=1&charset=utf-8&uid=${nick}&site=cntaobao&groupid=0&s=1`
  document.body.appendChild(iframe)
  setTimeout(() => document.body.removeChild(iframe), 1000)
}

export function handleVisitedJD(nick) {
  //  eslint-disable-next-line
  JmJsBridgePC.JMClient.checkJMClient(function (isInstall) {
    if (isInstall) {
      //  eslint-disable-next-line
      JmJsBridgePC.openJM({ pin: nick })
    }
  })
}

// 兼容明察系统分页
export const formatPageInfo = (params) => {
  const { current_page, page_size, currentPage, pageSize, ...rest } = params || {}

  const page = current_page || currentPage
  const size = page_size || pageSize
  if (lodash.isNumber(page) && lodash.isNumber(size)) {
    const skip = (page - 1) * size
    return {
      ...rest,
      skip: skip >= 0 ? skip : 0,
      limit: size,
    }
  }
  return rest
}

export const selectNode = (e: any) => {
  const text = e.target
  if (document.body.createTextRange) {
    const range = document.body.createTextRange()
    range.moveToElementText(text)
    range.select()
  } else if (window.getSelection) {
    const selection = window.getSelection()
    const range = document.createRange()
    range.selectNodeContents(text)
    selection?.removeAllRanges()
    selection?.addRange(range)
  }
}

export const calculPlatform = (platform: string) => {
  if (platform === 'tb') {
    return '淘宝'
  } else if (platform === 'jd') {
    return '京东'
  } else if (platform === 'ks') {
    return '快手'
  } else if (platform === 'pdd') {
    return '拼多多'
  } else if (platform === 'dy') {
    return '抖音'
  } else if (platform === 'open') {
    return '开放平台'
  } else {
    return '其他'
  }
}

const imgUrls = {}
export function isImgUrl(url: string) {
  return new Promise((resolve) => {
    if (!isUrl(url)) {
      resolve(false)
      return
    }
    if (imgUrls[url] === true) {
      resolve(true)
      return
    }
    if (imgUrls[url] === false) {
      resolve(false)
      return
    }
    const ImgObj = new Image() //判断图片是否存在
    ImgObj.src = url
    ImgObj.onload = () => {
      imgUrls[url] = true
      resolve(true)
    }
    ImgObj.onerror = () => {
      imgUrls[url] = false
      resolve(false)
    }
  })
}
// 字符过长设置显示长度
export const ellipsisText = (str, len = 0) => {
  if (str === undefined) return null
  if (str.length <= len) return str
  return `${str.substr(0, len + 1)}...`
}

export const revertTime = (time) => {
  const a = time * 1000
  const d = a ? new Date(a) : new Date()
  const year = d.getFullYear()
  const month = d.getMonth() + 1
  const day = d.getDate()
  const hours = d.getHours()
  const min = d.getMinutes()
  const seconds = d.getSeconds()
  return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day} ${
    hours < 10 ? `0${hours}` : hours
  }:${min < 10 ? `0${min}` : min}:${seconds < 10 ? `0${seconds}` : seconds}`
}
export const DDRevertTime = (time) => {
  const a = time * 1000
  const d = a ? new Date(a) : new Date()
  const month = d.getMonth() + 1
  const day = d.getDate()
  const hours = d.getHours()
  const min = d.getMinutes()
  const seconds = d.getSeconds()
  return `(${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day} ${
    hours < 10 ? `0${hours}` : hours
  }:${min < 10 ? `0${min}` : min}:${seconds < 10 ? `0${seconds}` : seconds})`
}
// 数据脱敏处理
export const handleDesen = (test: string) => {
  if (!test || test.length === 0) return ''
  return `${test[0]}****`
}

// 地址转换
/**
 * 替换 URL 中的域名
 * @param {string} url - 原始 URL
 * @param {string} newDomain - 替换为的新域名
 * @returns {string} 替换后的新 URL
 */
export const replaceDomain = (url, newDomain = 'https://cdn.pdd.myjjing.com') => {
  // 解析 URL 并提取路径部分
  const urlObj = new URL(url)
  // 返回新域名替换后的 URL
  return `${newDomain}${urlObj.pathname}${urlObj.search}${urlObj.hash}`
}

// 判断对象中是否只含有某个属性
export const isObjectOnlyWithProperty = (obj, propertyName) => {
  const keys = Object.keys(obj)
  return keys.length === 1 && keys[0] === propertyName
}

// 深层比较对象
export const deepEqual = (object1, object2) => {
  const keys1 = Object.keys(object1)
  const keys2 = Object.keys(object2)

  if (keys1.length !== keys2.length) {
    return false
  }

  for (let index = 0; index < keys1.length; index++) {
    const val1 = object1[keys1[index]]
    const val2 = object2[keys2[index]]
    const areObjects = isObject(val1) && isObject(val2)
    if ((areObjects && !deepEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
      return false
    }
  }

  return true
}

const isObject = (object) => {
  return object != null && typeof object === 'object'
}

// 复制文本
export const copyPolyfill = (text: string) => {
  const input = document.createElement('input')
  document.body.appendChild(input)
  input.style.position = 'fixed'
  input.style.opacity = '0'
  input.setAttribute('readonly', 'readonly')
  input.setAttribute('value', text)
  document.body.appendChild(input)
  input.select()
  document.execCommand('copy')
  document.body.removeChild(input)
  message.success('复制成功')
}

// 计算到期剩余时间
export const calculateDaysDifference = (dateString = 20240930) => {
  const year = parseInt(String(dateString).substring(0, 4), 10)
  const month = parseInt(String(dateString).substring(4, 6), 10) - 1
  const day = parseInt(String(dateString).substring(6, 8), 10)

  const targetDate = new Date(year, month, day)
  const currentDate = new Date()
  const difference = targetDate - currentDate
  const daysDifference = Math.ceil(difference / (1000 * 3600 * 24))

  return daysDifference
}

// 隐藏数据
export const maskString = (str, showFirstLast = 1, maskChar = '*') => {
  if (showFirstLast === 100) {
    if (str.length <= 9) {
      return str
    }
    return str.slice(0, 9) + '*'.repeat(str.length - 9)
  }
  if (!str || str.length <= showFirstLast * 2 + 1) {
    return str
      .split('')
      .map(() => maskChar)
      .join('')
  }
  const middleLength = str.length - showFirstLast * 2
  const middle = new Array(middleLength).fill(maskChar).join('')
  return str.slice(0, showFirstLast) + middle + str.slice(-showFirstLast)
}

export const getNowTime = () => {
  const now = new Date()

  const year = now.getFullYear()
  const month = now.getMonth() + 1
  const day = now.getDate()
  const hours = now.getHours()
  const minutes = now.getMinutes()
  const seconds = now.getSeconds()

  const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`
  const formattedTime = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${
    seconds < 10 ? '0' : ''
  }${seconds}`

  return `${formattedDate} ${formattedTime}`
}

// 检查图片链接是否可用
export const checkImageUrl = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.src = url
    img.onload = () => resolve(true)
    img.onerror = () => resolve(false) // 这里使用 resolve 而不是 reject，只是判断是否加载成功，而不是抛出错误
  })
}

export const getImageFileFromUrl = (url, fileName, fileType = 'image/jpeg', callback) => {
  return new Promise((resolve, reject) => {
    let blob = null
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url)
    xhr.setRequestHeader('Accept', fileType)
    xhr.responseType = 'blob'
    xhr.onload = () => {
      if (xhr.status === 200) {
        blob = xhr.response
        const file = new File([blob], fileName, { type: fileType })
        // callback.call(this, file)
        resolve(file)
      }
    }
    xhr.onerror = (e) => {
      reject(e)
    }
    xhr.send()
  })
}

// 检查视频链接是否可用
export const checkVideoUrl = async (url) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video')
    video.src = url
    video.addEventListener('canplaythrough', () => {
      resolve(true)
      video.remove()
    })
    video.addEventListener('error', () => {
      resolve(false)
      video.remove()
    })
    document.body.appendChild(video)
  })
}

export const dataURLtoFile = (dataurl, filename) => {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

// 压缩图片大小
export const compressImage = async (file, quality) => {
  const reader = new FileReader()
  reader.readAsDataURL(file)
  return new Promise((resolve, reject) => {
    reader.onload = async (event) => {
      const img = new Image()
      img.src = event.target.result
      img.onload = async () => {
        const canvas = document.createElement('canvas')
        const maxWidth = 800 // 设置最大宽度
        const scale = Math.min(1, maxWidth / img.width)
        canvas.width = img.width * scale
        canvas.height = img.height * scale
        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height)

        // 将Canvas内容转换为Base64编码的字符串
        const base64 = canvas.toDataURL(file.type, quality) // 调整参数改变压缩质量

        // 将Base64编码的字符串转换回File对象
        const newFile = dataURLtoFile(base64, file.name)
        resolve(newFile)
      }
    }
    reader.onerror = (error) => {
      reject(error)
    }
  })
}

export const getCookie = (name) => {
  const cookieArr = document.cookie.split(';')

  for (let i = 0; i < cookieArr.length; i++) {
    const cookiePair = cookieArr[i].split('=')

    if (name === cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1])
    }
  }
  return null
}

export const whiteList = (tenant_id) => {
  const list = getSlotDataList('voiceH5WhiteList')[0]?.list
  if (list?.includes(tenant_id)) return true
  else return false
}

export const isTest =
  window.location.host?.startsWith('localhost') ||
  window.location.host?.startsWith('training-dev-lane')
